import { useOutlet } from 'react-router-dom'

export default function PrintPage() {
  const outlet = useOutlet()

  return <div className='w-full h-full bg-neutral'>
    {outlet}
  </div>
}
